import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../components/button';

interface Props {
  title: string;
  btmTitle: string;
  videoLink: string;
}

const VideoInfoWithBtmSheet = ({title, btmTitle, videoLink}: Props) => {
  const [bottomSheet, setOpenBottomSheet] = useState<boolean>(false);

  return (
    <div>
      <div
        className="flex items-center gap-2 text-blue-100 cursor-pointer"
        onClick={() => setOpenBottomSheet(true)}
      >
        <span className="text-sm">{title}</span>
        <SpanIcon className="icon-namereport" />
      </div>

      <BottomSheet
        onDismiss={() => setOpenBottomSheet(false)}
        open={bottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col gap-8 px-4 py-6">
          {/* Header with close icon */}
          <div className="relative flex items-center justify-center">
            <span className="text-lg font-medium">{btmTitle}</span>
            <SpanIcon
              className="absolute left-0 text-2xl text-gray-700 cursor-pointer -top-1 icon-nameClose-remove"
              onClick={() => setOpenBottomSheet(false)}
            />
          </div>

          {/* Video player with autoplay muted */}
          <div className="w-full px-2 overflow-hidden rounded-lg aspect-video">
            <video
              controls
              autoPlay
              muted
              playsInline
              className="w-full h-full rounded-lg"
            >
              <source src={videoLink} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Dismiss button */}
          <Button
            onClick={() => setOpenBottomSheet(false)}
            className="w-full py-3 mt-2 text-white transition-colors rounded-lg bg-farm-shop-500 hover:bg-farm-shop-600 "
            size="small"
          >
            متوجه شدم
          </Button>
        </div>
      </BottomSheet>
    </div>
  );
};

export default VideoInfoWithBtmSheet;
